export const isAllowedForRegion = process.env.REACT_APP_IS_EU !== "true"


